import React, { useState, useEffect } from 'react';
import { Link } from 'react-router-dom';
import logo from '../logo.png';

function Navbar(props) {
  return (
    <header>
        <div className="container">
            <div className="logo">
              <img src={logo} alt="Blingerator" />
              <span>Blingerator</span>
            </div>
        </div>
    </header>
  );
}

export default Navbar;